export interface IStandingType {
  cash: number | string;
  points: number | string;
  scrip: number | string;
}

export type TStandingType = keyof IStandingType;

export interface IAward extends IStandingType {
  id: number;
  user: number;
  type: string;
  note?: string;
  hole: null | number;
  team: null | number;

  touched?: any;
}

export interface IAwards {
  [awardId: number]: IAward;
}

export interface IAdminEventAwardsStore {
  [roundId: number]: IAwards;
}

export const adminEventAwardsStore: IAdminEventAwardsStore = {};
